// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3zIBq","modalForm":"UpgradeEpcsModal_modalForm__3r17T","modalFooter":"UpgradeEpcsModal_modalFooter__2dnTw"};